module.exports = __webpack_public_path__ + "img/borderRightLongWhite.75a30758.svg";